import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PolicyType } from './policy-types.model';
import { PermissionValidator } from './permission.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  policies = new BehaviorSubject<PolicyType[]>([]);
  policies$ = this.policies.asObservable();
  constructor() {}

  private userHasPolicy(policy: PolicyType, policies: PolicyType[]): boolean {
    return this.toStringArray(policies).some(val => val === policy);
  }

  private toStringArray(policy: PolicyType | PolicyType[]): string[] {
    if (typeof policy === 'object') {
      // if PolicyType[], just return it
      return policy;
    }
    // ..otherwise create an array and add the single policy
    const policies = [] as string[];
    policies.push(policy);
    return policies;
  }

  currentUserCan(validator: PermissionValidator): Observable<boolean> {
    return this.policies$.pipe(
      map(val => {
        if (val.length > 0) {
          if (validator.validateAll) {
            return validator.policies.every(value => this.userHasPolicy(value, val));
          } else {
            return validator.policies.some(value => this.userHasPolicy(value, val));
          }
        }
        return false;
      })
    );
  }
}
